<mat-dialog-content>
  <h2 mat-dialog-title matTooltip="Schedule">Schedule</h2>

  <div class="toggle_radio" *ngIf="scheduleSettingsMode != scheduleSettingsModes.On">

    <input type="radio" [checked]="scheduleSettingsMode == scheduleSettingsModes.Off" class="toggle_option"
      id="first_toggle" name="toggle_option" (change)="onScheduleSettingChange($event, scheduleSettingsModes.Off)">

    <input type="radio" [checked]="scheduleSettingsMode == scheduleSettingsModes.Daily" class="toggle_option"
      id="second_toggle" name="toggle_option" (change)="onScheduleSettingChange($event, scheduleSettingsModes.Daily)">

    <input type="radio" [checked]="scheduleSettingsMode == scheduleSettingsModes.Weekly" class="toggle_option"
      id="third_toggle" name="toggle_option" (change)="onScheduleSettingChange($event, scheduleSettingsModes.Weekly)">

    <input type="radio" [checked]="scheduleSettingsMode == scheduleSettingsModes.Range" class="toggle_option"
      id="fourth_toggle" name="toggle_option" (change)="onScheduleSettingChange($event, scheduleSettingsModes.Range)">

    <label for="first_toggle">
      <p matTooltip="Off">Off</p>
    </label>
    <label for="second_toggle">
      <p matTooltip="Daily">Daily</p>
    </label>
    <label for="third_toggle">
      <p matTooltip="Weekly">Weekly</p>
    </label>
    <label for="fourth_toggle">
      <p matTooltip="Range">Range</p>
    </label>

    <div class="toggle_option_slider" [ngSwitch]="scheduleSettingsMode">
      <label *ngSwitchCase="scheduleSettingsModes.Off">
        <p matTooltip="Off">Off</p>
      </label>
      <label *ngSwitchCase="scheduleSettingsModes.Daily">
        <p matTooltip="Daily">Daily</p>
      </label>
      <label *ngSwitchCase="scheduleSettingsModes.Weekly">
        <p matTooltip="Weekly">Weekly</p>
      </label>
      <label *ngSwitchCase="scheduleSettingsModes.Range">
        <p matTooltip="Range">Range</p>
      </label>
    </div>
  </div>

  <div *ngIf="scheduleSettingsMode == scheduleSettingsModes.On" class="layout">
    <p class="grey-label">This schedule is not active now. You can turn it on</p>
    <div class="row button-overlay">
      <button mat-button type="button" class="btn-schedule btn-green" (click)="turnOn()" matTooltip="Turn On">Turn
        On</button>
    </div>
  </div>

  <div *ngIf="scheduleSettingsMode == scheduleSettingsModes.Off" class="layout">
    <p class="grey-label">Deactivate the scheduler</p>
    <div class="row button-overlay">
      <button mat-button type="button" class="btn-schedule btn-red" (click)="turnOff()"
        [disabled]="scheduleModelMode==scheduleModalModes.Create || !schedule.Id" matTooltip="Turn off">Turn
        off</button>
    </div>
    <div class="row button-overlay">
      <button mat-button type="button" class="btn-schedule btn-black" (click)="delete()"
        [disabled]="scheduleModelMode==scheduleModalModes.Create || !schedule.Id"
        matTooltip="Remove from calendar">Remove from calendar</button>
    </div>
  </div>

  <div class="form-container">

    <form [formGroup]="form" (ngSubmit)="save()">
      <div *ngIf="scheduleSettingsMode < scheduleSettingsModes.Off" class="layout">
        <div class="row d-flex align-items-center mb-2 mt-2 pt-1 pb-1">
          <div class="col-md-12 d-flex align-items-center justify-content-center" *ngIf="!longTermMode">
            <mat-checkbox class="schedule-all-day" formControlName="AllDay" [disableRipple]="true" matTooltip="All Day"
              (change)="onAllDayValueChanged($event.checked)">
              All Day
            </mat-checkbox>
          </div>
        </div>

        <div *ngIf="!AllDay.value">
          <div class="row mb-2">
            <label for="StartTime" class="col-md-5" matTooltip="Start Time">
              Start Time:
            </label>

            <div class="col-md-7">
              <input class="form-control schedule-form-control" type="time" step="1" autocomplete="off" id="StartTime"
                formControlName="StartTime" required>
            </div>
          </div>


          <div class="row">
            <label for="EndTime" class="col-md-5" matTooltip="End Time">
              End Time:
            </label>

            <div class="col-md-7">
              <input class="form-control schedule-form-control" type="time" step="1" autocomplete="off" id="EndTime"
                formControlName="EndTime">
            </div>
          </div>

          <div *ngIf="(StartTime?.touched && StartTime?.errors) || (EndTime?.touched && EndTime?.errors)"
            class="invalid-input">
            <div *ngIf="StartTime?.errors?.required && !StartTime?.errors?.required">Start time is required!</div>
            <div *ngIf="EndTime?.errors?.required && !EndTime?.errors?.required">End time is required!</div>
            <div *ngIf="StartTime?.errors?.owlDateTimeParse">Start time has invalid format!</div>
            <div *ngIf="EndTime?.errors?.owlDateTimeParse">End time has invalid format!</div>
            <div *ngIf="StartTime?.errors?.incorrectOrder || EndTime?.errors?.incorrectOrder">Start time must occur
              before End time!</div>
            <div *ngIf="StartTime?.errors?.lessThanMinute || EndTime?.errors?.lessThanMinute">Set at least one minute
              difference!</div>
          </div>
        </div>

      </div>

      <div *ngIf="scheduleSettingsMode == scheduleSettingsModes.Weekly" class="layout">
        <hr>
        <div class="row" formGroupName="WeekDays">
          <ng-container *ngFor="let day of weekdays">
            <div class="col-md-6 week-day">
              <mat-checkbox [name]="day" [formControlName]="day" [disableRipple]="true" [matTooltip]="day">{{ day }}
              </mat-checkbox>
            </div>
          </ng-container>
        </div>

        <div *ngIf="WeekDays?.errors?.weekDaysError && WeekDays?.touched" class="invalid-input">Select at least one day!
        </div>
      </div>

      <div *ngIf="scheduleSettingsMode == scheduleSettingsModes.Range && !longTermMode" class="layout">
        <hr>

        <div class="row mb-2">
          <label for="dts" class="col-md-5" matTooltip="Start Date">
            Start Date:
          </label>

          <div class="col-md-7">
            <input class="form-control schedule-form-control" type="text" formControlName="StartDate" autocomplete="off"
              [owlDateTimeTrigger]="dts" [owlDateTime]="dts" [min]="minDate" readonly="readonly">
            <owl-date-time [pickerType]="'calendar'" #dts></owl-date-time>
          </div>
        </div>

        <div class="row">
          <label for="dtf" class="col-md-5" matTooltip="End Date">
            End Date:
          </label>

          <div class="col-md-7">
            <input class="form-control schedule-form-control" type="text" formControlName="EndDate" autocomplete="off"
              [owlDateTimeTrigger]="dtf" [owlDateTime]="dtf" [min]="minDate" readonly="readonly">
            <owl-date-time [pickerType]="'calendar'" #dtf></owl-date-time>
          </div>
        </div>

        <div *ngIf="(StartDate.touched && StartDate.errors) || (EndDate?.touched && EndDate?.errors)"
          class="invalid-input">
          <div *ngIf="StartDate?.errors?.required">Start date is required!</div>
          <div *ngIf="EndDate?.errors?.required">End date is required!</div>
          <div *ngIf="EndDate?.errors?.EndBiggerThanStart || StartDate?.errors?.EndBiggerThanStart">End date must be
            bigger or equal to start date!</div>
        </div>

      </div>

      <div
        *ngIf="scheduleSettingsMode != scheduleSettingsModes.Off && scheduleSettingsMode != scheduleSettingsModes.On">
        <hr>
        <div class="row button-overlay">
          <button mat-button type="submit" class="btn-schedule btn-green" [disabled]="form.invalid || saveIsInProgress"
            matTooltip="Save schedule">
            Save schedule
          </button>
        </div>
      </div>
    </form>

  </div>
</mat-dialog-content>